module.exports = require("halosee-ui/src/locale/lang/en");